<template>
  <div id="call-management" :class="this.$lang === 'ar' ? 'regular-ar' : 'regular-en'">
    <div v-if="error" class="response-handle">
      <Error />
    </div>
    <div v-if="load" class="response-handle">
      <Loader />
    </div>
    <div v-if="!error && !load" class="header-container position-relative">
      <div class="inner-container d-flex">
        <div class="header-titles">
          <div class="header-data">
            <div :class="['header-title', this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en']">{{title}}</div>
<!--            <div class="description">{{desc}}</div>-->
          </div>
        </div>
        <img :class="[this.$lang === 'ar' ? 'right' : 'right', 'header-img d-block']" src="../../assets/images/callManagement.png" class="internationalIcon">
        <div v-observe-visibility="visibilityChanged"></div>
        <div class="lottie">
          <vue-lottie-player :key="key"  name="anime" ref="lottie" width="100%" height="100%" style="position: absolute; left: 0px; top: 0px" :animationData="jsonFile" />
        </div>
      </div>
    </div>
    <div v-if="!error && !load" class="main-content">
      <div class="content-header">
        <div :class="[this.$lang === 'ar' && 'rotate right-dir', 'tabs-container']" style="width: 100%">
          <v-tabs
            v-model="tab"
            grow
            centered
            show-arrows
            class="line-tabs left-dir"
          >
            <v-tabs-slider color="#FFCB05" ></v-tabs-slider>
            <v-tab
              v-for="item in info.items" :key="item.title" :active-class="lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">{{ item.title }}
            </v-tab>
          </v-tabs>
        </div>
      </div>
      <v-tabs-items v-model="tab" :touchless="true">
        <div class="products-container">
          <v-tab-item v-for="item in info.items" :key="item.title">
            <component :is="item.comp" :additionalInfo="item.additionalInfo" :lineCard="item.lineCard" />
          </v-tab-item>
        </div>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import CallManagementContent from './CallManagementContent'
import ProductsCategories from '../../repositories/ProductsCategories'
import json from '../../assets/json/callManagement.json'
import background from '../../assets/images/mobileBackground.png'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
import VueLottiePlayer from 'vue-lottie-player'
import $ from 'jquery'
export default {
  components: { CallManagementContent, Loader, Error, VueLottiePlayer },
  data () {
    return {
      background: background,
      jsonFile: json,
      key: 0,
      productsCategoryRepo: new ProductsCategories(1),
      tab: null,
      info: { items: [] },
      activeTab: '',
      lang: this.$lang,
      desc: '',
      title: '',
      load: false,
      error: false,
      activeId: null
    }
  },
  created () {
    this.activeId = this.$route.params.type
    this.fetchData()
  },
  mounted () {
    this.$lang === 'ar' && $('#call-management .v-tab').css('transform', 'rotateY(180deg)')
  },
  watch: {
    tab (val) {
      this.$store.state.productsInnerTab = val
    }
  },
  methods: {
    checkActiveTab (items, active) {
      return items.findIndex(o => o.id === Number(active))
    },
    visibilityChanged (isVisible) {
      if (isVisible) {
        this.key++
        this.$forceUpdate()
      }
    },
    async fetchData () {
      this.load = true
      try {
        const response = await this.productsCategoryRepo.get()
        if (response.status === 200) {
          this.desc = response.data.description
          this.title = response.data.title
          for (let i = 0; i < response.data.serviceFeatures.length; i++) {
            this.info.items.push({
              id: response.data.serviceFeatures[i].id,
              title: response.data.serviceFeatures[i].title,
              comp: 'CallManagementContent',
              lineCard: response.data.serviceFeatures[i].html,
              additionalInfo: response.data.serviceFeatures[i].featureInfos
            })
          }
          if (this.activeId !== null) {
            // Search for for example prices list tab via id
            this.tab = this.checkActiveTab(this.info.items, this.activeId)
          }
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
        console.log(e)
      }
      this.load = false
      setTimeout(() => {
        this.$lang === 'ar' && $('#call-management .v-tab').css('transform', 'rotateY(180deg)')
        this.$lang === 'ar' ? $('.v-tab').css('direction', 'rtl') : $('.v-tab').css('direction', 'ltr')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/modules/products";
.response-handle{
  min-height: calc(100vh - (155px + 285.5px));
  display: flex;
  align-items: center;
  justify-content: center;
}
.rotate{
  transform: rotateY(180deg) !important;
}
.description{
  width: 100%; margin: 0 auto; text-align: center;
}
.left{
  left: 0px
}
.right{
  right: 0px;
}
.header-container{
  width: 100%;
  min-height: 370px;
  text-align: initial;
  position: relative;
  z-index: 0;
}
.inner-container{
  background: linear-gradient(-45deg , rgba(255,203, 5, 1 ), rgba(255,203, 5, .5 ));
  min-height: 370px;
  position: relative;
  z-index: -2;
  .header-titles{
    padding-bottom: 40px;
    width: 50%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 40px;
    .header-data{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 20px 0
    }
    .header-title{
      color: #fff;
      font-size: 30px;
    }
  }
}
.header-img{
  /*width:364px;*/
  height: 100%;
  display: inline-block;
  position: absolute;
  /*<!--bottom: -50px;-->*/
  z-index: 1;
}
#call-management .header-img{
  /*width: 1500px;*/
  height: auto;
  width: auto;
  bottom: 0px;

  /*<!--left: -90px;-->*/
  /*transform: rotateY(180deg);*/
}
/*@media (max-width: 1230px) {*/
/*  img.header-img {*/
/*    height: 300px;*/
/*    width: 300px;*/
/*    bottom: 0;*/
/*    top: unset;*/
/*  }*/
/*}*/
@media screen and (max-width: 1280px){
  #call-management .header-img, .lottie{
    display: none !important;
  }
  #call-management .content-header{
    bottom: -50px;
  }
}
@media screen and (max-width: 1000px){
  .description{
    padding-bottom: 0px;
  }
  .header-titles{
    width: 90% !important;
  }
  /*img.header-img{*/
  /*  display: block;*/
  /*  position: unset;*/
  /*  margin: 0 auto;*/
  /*}*/
}
</style>
<style lang="scss">
#call-management{
  padding: 1px;
  box-sizing: border-box;
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active){
    color: rgba(29, 29, 29, 0.6) !important;
  }
  .v-tabs{
    height: 100%;
    border: none !important;
  }
  .v-tab{
    font-size: 12px !important;
    border-bottom: 2px solid #ffffff;
    text-transform: capitalize;
  }
  .v-tab.v-tab--active{
    color: #FFCB05;
  }
  .v-window.v-item-group.theme--light.v-tabs-items{
    background: transparent;
  }
}
</style>
